module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/JOURNALISM-92a23f5762106978173ac0a7be986c2e.png";